import { render, staticRenderFns } from "./EmailMarketingEdit.vue?vue&type=template&id=23424e8c&scoped=true"
import script from "./EmailMarketingEdit.vue?vue&type=script&lang=js"
export * from "./EmailMarketingEdit.vue?vue&type=script&lang=js"
import style0 from "./EmailMarketingEdit.vue?vue&type=style&index=0&id=23424e8c&prod&lang=scss"
import style1 from "./EmailMarketingEdit.vue?vue&type=style&index=1&id=23424e8c&prod&lang=scss&scoped=true"
import style2 from "./EmailMarketingEdit.vue?vue&type=style&index=2&id=23424e8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23424e8c",
  null
  
)

export default component.exports